/**
 * First and last initial.
 *
 * Its own file so `PersonAvatar.tsx` exports only a component — a module that
 * mixes the two breaks Fast Refresh, so every edit to it reloads the page and
 * loses whatever state was on screen.
 *
 * A middle name should not displace the surname: "Aarav Kumar Sharma" is AS.
 */
export function initials(fullName: string): string {
  const words = fullName.trim().split(/\s+/).filter(Boolean);
  const first = words[0]?.[0] ?? '';
  const last = words.length > 1 ? (words[words.length - 1]?.[0] ?? '') : '';
  return (first + last).toUpperCase();
}
